import * as React from "react";
import { UserAuth, UserContextType } from "app/context/AuthContext";
import { getFormValues } from "app/utils/getFormValues";
import { useNavigate } from "react-router";
import { Path } from "app/path";
import firebaseAuth from "app/utils/firebase";
import { toast } from "react-toastify";
import { useQuery } from "app/utils/useQuery";
import http from "../../requests/axiosInstance";

export const useSignin = () => {
  const navigate = useNavigate();
  const query = useQuery();
  const { emailPassSignIn, init,login } = UserAuth() as UserContextType;
  const [loading, setLoading] = React.useState<boolean>(false);
  const [showPassword, setShowPassword] = React.useState<boolean>(false);

  // const handleSigninSubmit = async (event: any, activeTab:string) => {
  //   event.preventDefault();
  //   const { email, password } = getFormValues(event.target);
  //
  //   try {
  //     setLoading(true);
  //     // await emailPassSignIn(email, password);
  //     // const user = firebaseAuth.currentUser;
  //    const user=await login(email,password)
  //     await init(user);
  //     const redirectUrl = query.get("redirectUrl");
  //     if (redirectUrl) {
  //       navigate(redirectUrl);
  //     } else {
  //       navigate(Path.HOME);
  //     }
  //   } catch (error: any) {
  //     if (
  //       error.code === "auth/wrong-password" ||
  //       error.code === "auth/user-not-found"
  //     ) {
  //       toast.error("Your email or password is incorrect");
  //     }
  //   } finally {
  //     setLoading(false);
  //   }
  // };

    const handleSigninSubmit = async (
        e: React.FormEvent<HTMLFormElement>,
        loginType: "admin" | "employee"
    ) => {
        e.preventDefault();
        setLoading(true);

        const formData = new FormData(e.currentTarget);

        const payload: any = {
            email: formData.get("email"),
            password: formData.get("password"),
            role: loginType,
        };

        if (loginType === "employee") {
            payload.employeeCode = formData.get("employeeCode");
        }

        try {
            // backend decides auth logic based on role
            // await http.post("/v1/auth/login", payload);
         const user= await  login(payload)
           // await init(user)

        } finally {
            setLoading(false);
        }
    };

  return { handleSigninSubmit, loading, showPassword, setShowPassword };
};
